// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsAndConditions_termsContainer__8nh2K {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.7;
  color: #333;
  background-color: #fafafa;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
}

.TermsAndConditions_title__RhiuF {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
  text-align: center;
}

.TermsAndConditions_lastUpdated__CM7RZ {
  font-size: 0.95rem;
  color: #666;
  text-align: center;
  margin-bottom: 25px;
  font-style: italic;
}

.TermsAndConditions_intro__qfj1v {
  font-size: 1rem;
  color: #444;
  margin-bottom: 25px;
}

.TermsAndConditions_section__IUWjc {
  margin-bottom: 30px;
}

.TermsAndConditions_sectionTitle__t\\+qRT {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #222;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 5px;
}

.TermsAndConditions_subSectionTitle__jQo\\+Q {
  font-size: 1.25rem;
  font-weight: 500;
  margin-top: 15px;
  margin-bottom: 10px;
  color: #333;
}

.TermsAndConditions_text__et5\\+Y {
  font-size: 1rem;
  color: #555;
  margin-bottom: 12px;
}

.TermsAndConditions_list__iBZJs {
  list-style: disc;
  margin-left: 25px;
  margin-bottom: 15px;
}

.TermsAndConditions_listItem__4Uq4\\+ {
  margin-bottom: 8px;
  color: #555;
}

.TermsAndConditions_footer__tmBUj {
  margin-top: 40px;
  border-top: 1px solid #ddd;
  padding-top: 20px;
  text-align: center;
}

.TermsAndConditions_footerText__sCg94 {
  font-size: 0.9rem;
  color: #888;
}

/* Scrollable for smaller screens */
@media (max-width: 768px) {
  .TermsAndConditions_termsContainer__8nh2K {
    padding: 20px 15px;
  }

  .TermsAndConditions_title__RhiuF {
    font-size: 2rem;
  }

  .TermsAndConditions_sectionTitle__t\\+qRT {
    font-size: 1.5rem;
  }

  .TermsAndConditions_subSectionTitle__jQo\\+Q {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/TermsAndConditions.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".termsContainer {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 30px 20px;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.7;\n  color: #333;\n  background-color: #fafafa;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  overflow-x: hidden;\n}\n\n.title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #1a1a1a;\n  text-align: center;\n}\n\n.lastUpdated {\n  font-size: 0.95rem;\n  color: #666;\n  text-align: center;\n  margin-bottom: 25px;\n  font-style: italic;\n}\n\n.intro {\n  font-size: 1rem;\n  color: #444;\n  margin-bottom: 25px;\n}\n\n.section {\n  margin-bottom: 30px;\n}\n\n.sectionTitle {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: #222;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 5px;\n}\n\n.subSectionTitle {\n  font-size: 1.25rem;\n  font-weight: 500;\n  margin-top: 15px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.text {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 12px;\n}\n\n.list {\n  list-style: disc;\n  margin-left: 25px;\n  margin-bottom: 15px;\n}\n\n.listItem {\n  margin-bottom: 8px;\n  color: #555;\n}\n\n.footer {\n  margin-top: 40px;\n  border-top: 1px solid #ddd;\n  padding-top: 20px;\n  text-align: center;\n}\n\n.footerText {\n  font-size: 0.9rem;\n  color: #888;\n}\n\n/* Scrollable for smaller screens */\n@media (max-width: 768px) {\n  .termsContainer {\n    padding: 20px 15px;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .sectionTitle {\n    font-size: 1.5rem;\n  }\n\n  .subSectionTitle {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"termsContainer": `TermsAndConditions_termsContainer__8nh2K`,
	"title": `TermsAndConditions_title__RhiuF`,
	"lastUpdated": `TermsAndConditions_lastUpdated__CM7RZ`,
	"intro": `TermsAndConditions_intro__qfj1v`,
	"section": `TermsAndConditions_section__IUWjc`,
	"sectionTitle": `TermsAndConditions_sectionTitle__t+qRT`,
	"subSectionTitle": `TermsAndConditions_subSectionTitle__jQo+Q`,
	"text": `TermsAndConditions_text__et5+Y`,
	"list": `TermsAndConditions_list__iBZJs`,
	"listItem": `TermsAndConditions_listItem__4Uq4+`,
	"footer": `TermsAndConditions_footer__tmBUj`,
	"footerText": `TermsAndConditions_footerText__sCg94`
};
export default ___CSS_LOADER_EXPORT___;
